(function(angular, schoolwork12) {
    'use strict';
    
    angular.module(schoolwork12.app.auth.name)
    .controller(schoolwork12.app.auth.controllers.logout, 
                ['$scope', '$location', 'storage', schoolwork12.app.auth.services.authentication,
                        schoolwork12.app.common.services.eventNotification,
                            function($scope, $location, storage, authentication, eventNotification )
                            {
                                console.info('calling logout Controller:......'.concat(authentication.getCurrentUser().keycode));
                                
                                authentication.logout();
                                authentication.clear();
                                storage.setData('X-API-TOKEN', null);
                                eventNotification.broadcast(schoolwork12.app.auth.events.userLoggedOut, authentication.getCurrentUser());
                                $location.url(schoolwork12.app.auth.routes.login);

                                // var promise = authentication.logout();
                                // promise.then(
                                //         function(response) {
                                //            if (response) {
                                //               authentication.clear();
                                //               storage.setData('X-API-TOKEN', null);

                                              


                                //               $location.url(schoolwork12.app.auth.routes.login);
                                //             }
                                //         }, function(error) {
                                //               console.info('Failed to logout: '.concat(angular.toJson(error)));  
                                //               $location.url(schoolwork12.app.auth.routes.login);                                                               $location.url(schoolwork12.app.auth.routes.login);
                                //         }
                                // );


                            }
                ]
               );
    
}(angular, schoolwork12));
